import React, { ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { FormComponent } from 'components';
import { NOTI_MENU_URL } from 'data/menu';
import { useInfiniteScroll } from 'hooks';
import { PushQuery } from 'queries';
import * as M from 'styles/mobile';
import { IPushMessage, PushStatus, SearchPushFilterType } from 'types';
import {
  PUSH_DESTINATION_LABEL,
  PUSH_STATUS_LABEL,
  PUSH_TYPE_LABEL,
} from '../constants';
import * as S from './style';

const STATUS_TONE: Record<PushStatus, M.Tone> = {
  DRAFT: 'grey',
  SCHEDULED: 'info',
  SENDING: 'info',
  SENT: 'success',
  FAILED: 'error',
  CANCELED: 'grey',
};

const getSendDate = ({ sentAt, sendAt }: IPushMessage) => {
  if (sentAt) return `발송 ${dayjs(sentAt).format('YYYY-MM-DD HH:mm')}`;
  if (sendAt) return `예약 ${dayjs(sendAt).format('YYYY-MM-DD HH:mm')}`;
  return '';
};

interface Props {
  title?: ReactNode;
}

function MobileList({ title }: Props) {
  const navigate = useNavigate();
  const pushUrl = NOTI_MENU_URL['앱 푸시 관리'];
  const [filter, setFilter] = useState<SearchPushFilterType>({});

  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    PushQuery.useGetInfinite(filter);
  const sentinelRef = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  const pushes = data ?? [];

  return (
    <>
      <div css={M.stickyTop}>
        {title}
        <FormComponent.Form
          submit={(d: SearchPushFilterType) =>
            setFilter({ title: d.title || undefined })
          }
        >
          <FormComponent.SearchInput
            name="title"
            placeholder="제목으로 검색해주세요"
          />
        </FormComponent.Form>
      </div>
      <div css={M.list}>
        {pushes.map((push) => (
          <button
            key={push.id}
            type="button"
            css={M.listItem}
            onClick={() => navigate(`${pushUrl}/${push.id}`)}
          >
            <div css={S.titleWrap}>
              <span css={[M.tag(STATUS_TONE[push.status]), S.tagOffset]}>
                {PUSH_STATUS_LABEL[push.status]}
              </span>
              <p css={S.title}>{push.title}</p>
            </div>
            <div css={M.listRow}>
              <p css={S.meta}>
                {PUSH_DESTINATION_LABEL[push.destinationType]}
                {push.destinationDetail ? ` (#${push.destinationDetail})` : ''}
                {` · ${PUSH_TYPE_LABEL[push.pushType]}`}
              </p>
              <span css={M.listDate}>{getSendDate(push)}</span>
            </div>
          </button>
        ))}
        {!isLoading && pushes.length === 0 && (
          <p css={M.empty}>검색 결과가 없습니다</p>
        )}
        {isFetchingNextPage && <p css={M.empty}>불러오는 중...</p>}
      </div>
      <div ref={sentinelRef} css={M.sentinel} />
    </>
  );
}

export default MobileList;
